<div class="navbar-top mater">

    <div>
        <img class="big-navbar-img" style="margin-inline-start: 0px; widows: 150px;height: 46px; z-index: 9999;"
            src="./assets/landing/autoplusLogo.png" alt="autoecoleplus.tn">
        <img class="small-navbar-img" style="margin-inline-start: 0px; widows: 150px;height: 46px; z-index: 9999;"
            src="./assets/landing/minilogo2.svg" alt="autoecoleplus.tn">

    </div>

    <div class="buttons">
        @if (!_bulkSchedulingStateService.isFullscreenMode()) {

            <button
                mat-icon-button
                class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()"
                fxHide.lt-lg>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <button
                mat-icon-button
                class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()"
                fxHide.gt-md>
                <mat-icon class="secondary-text">arrow_back</mat-icon>
            </button>

        } @else {

            <button
                mat-icon-button
                class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()">
                <mat-icon class="secondary-text">arrow_back</mat-icon>
            </button>

        }
    </div>

</div>

<div class="solde-shortcut-btn" [ngClass]="{'solde-shortcut-btn-urgent': agencyBalance < 10}">
    <button class="recharge-shortcut-btn" [routerLink]="'/administration/payment/fixed'">
        <mat-icon>add</mat-icon>
    </button>
</div>

<div class="space-between"></div>

<div class="navbar-scroll-container"  *transloco="let t">
    <div class="solde-container" *accessControl="{ permissions: administrationPermissions['view-solde-facturation']}" [ngClass]="{'solde-container-urgent': agencyBalance < 10, 'show': !folded}" [@slideInOut]>
        <div class="balance-label"  >{{t('navbar.solde')}}</div>
        <div class="balance-content">
            <span class="balance">
                <span class="montant">{{billingState.balance() | number:'1.0-3'}}</span> 
                <span> {{t('navbar.TND')}}</span>
            </span>
            <button mat-stroked-button class="recharge-btn" [routerLink]="'/administration/payment/fixed'">
                <mat-icon>add</mat-icon>
                <span>{{t('navbar.Recharger')}}</span>
            </button>
        </div>
    </div>
    <div class="navbar-content" fusePerfectScrollbar  [fusePerfectScrollbarOptions]="{suppressScrollX: true}">
        <fuse-navigation layout="vertical"></fuse-navigation>
    </div>

</div>

<div class="navbar-footer">
    <div *ngIf="showUpgradePlan" class="upgrade-button mb-4" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" [routerLink]="'/administration/payment-choice'" [queryParams]="{upgrade: 'true'}">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="white"><path d="m98-537 168-168q14-14 33-20t39-2l52 11q-54 64-85 116t-60 126L98-537Zm205 91q23-72 62.5-136T461-702q88-88 201-131.5T873-860q17 98-26 211T716-448q-55 55-120 95.5T459-289L303-446Zm276-120q23 23 56.5 23t56.5-23q23-23 23-56.5T692-679q-23-23-56.5-23T579-679q-23 23-23 56.5t23 56.5ZM551-85l-64-147q74-29 126.5-60T730-377l10 52q4 20-2 39.5T718-252L551-85ZM162-318q35-35 85-35.5t85 34.5q35 35 35 85t-35 85q-25 25-83.5 43T87-74q14-103 32-161t43-83Z"/></svg>
        <span>
            Améliorer
        </span>
    </div>
    <!-- <div class="nouveau-tarif-box" *transloco="let t ">
        <button class="nouveau-tarif-btn" (click)="openLatestAppUpdate()">
            < <mat-icon class="nouveau-tarif-icon">campaign</mat-icon> >
            <span>{{t('navbar.NouveauTarif')}}</span>
        </button>
    </div> -->
    <div class="contact-phone-box">
        <a class="contact-phone-link" href="tel:+21650889833">
            <mat-icon class="phone-icon">phone</mat-icon>
            <span>50 889 833</span>
        </a>
    </div>
    <div class="invite-box" *transloco="let t ">
        <button mat-flat-button [routerLink]="'/referral'">
            <mat-icon class="giftcard-icon">card_giftcard</mat-icon>
            {{t('navbar.Inviteretgagner')}}
        </button>
    </div>
    <div class="reclamation-box" *transloco="let t ">
        <button class="reclamation-btn" (click)="openReclamationDialog()">
            <mat-icon class="reclamation-icon">forum</mat-icon>
            <span>{{t('navbar.Contactez-nous')}}</span>
        </button>
    </div>
</div>